import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'

interface HeroCTAProps {
  fullWidth?: boolean
  outcomeName: string
}

export const HeroCTA = ({ fullWidth = false, outcomeName }: HeroCTAProps) => (
  <>
    <CTA
      fullWidth={fullWidth}
      className='mc-mb-3 mc-px-9'
      trackProps={{
        category: outcomeName,
        content_type: 'product',
        location: 'hero',
      }}
    />
    <p className={fullWidth ? 'mc-px-10 mc-text--center' : ''}>
      <PricingText
        translationKey='long'
        className={`mc-opacity--hinted mc-text-small ${fullWidth ? '' : 'mc-text--left'}`}
      />
    </p>
  </>
)
